<template>
  <button
    :class="['dismiss-alert-button', { 'is-absolute': absolute }]"
    data-cy="alert-dismiss-button"
    @click="$emit('onClick')"
    :style="style"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.87545 15.2082L0.733887 14.0666L6.80055 7.99998L0.733887 1.93331L1.87545 0.791748L7.94212 6.85841L14.0088 0.791748L15.1503 1.93331L9.08368 7.99998L15.1503 14.0666L14.0088 15.2082L7.94212 9.14154L1.87545 15.2082Z"
        fill="#1C1B1F"
      />
    </svg>
  </button>
</template>

<script setup lang="ts">

defineProps({
  style: {
    type: Object,
  },
  absolute: {
    type: Boolean,
    default: true,
  },
});
defineEmits(["onClick"]);
</script>

<style lang="scss" scoped>
.dismiss-alert-button {
  background: none;
  border: none;
  padding: 0;
  color: white;
  margin: 0;

  &.is-absolute {
    position: absolute;
    top: 2%;
    right: 4%;
  }
}

i {
  width: 14.416px;
  height: 14.416px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
}
</style>
